import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function AddVentureDocument(props) {
    const [user] = useContext(AuthContext);
    const [file, setFile] = useState(null);
    const [name, setName] = useState(null);
    const [group, setGroup] = useState(null);

    const _submit = (e) => {
        e.preventDefault();
        if (file !== null) {
            const data = new FormData();
            data.append('document', file);
            data.append('name', name);
            data.append('group', group !== '' ? group : null);
            if (props.add?.venture_agreement_id) {
                data.append('venture_agreement_id', props.add.venture_agreement_id);
            }
            if (props.add?.agreement_protocol_id) {
                data.append('agreement_protocol_id', props.add.agreement_protocol_id);
            }
            fetch(`/api/venture/${props.add.venture_id}/document`, {
                method: 'POST',
                body: data,
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => {
                    props.onSuccess(json);
                    props.dismissPanel();
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    useEffect(() => {
        setName(null);
        setGroup(null);
        setFile(null);
    }, [props.add])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddVentureDocument'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Dokument"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddVentureDocument'>
                <TextField required label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <TextField label='Grupa' value={group} onChange={(e) => setGroup(e.target.value || '')}/>
                <br/>
                <input type="file" name="file" onChange={(e) => setFile(e.target.files[0])}/>
            </form>
        </Panel>
    )
}

export default AddVentureDocument;